import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { paymentMethodConfig } from './PaymentMethod.name';

/** 支払方法のENUM */
enum PaymentMethod {
  /** 先払い */
  advancePayment = '1',
  /** 後払い */
  laterPayment = '2',
}

const paymentMethodMap = new Map([
  ['1', PaymentMethod.advancePayment],
  ['2', PaymentMethod.laterPayment],
]);

function rawValueToPaymentMethod(rawValue: string) {
  return rawValueToEnumWithDefault(paymentMethodMap, PaymentMethod.laterPayment)(rawValue);
}

const paymentMethodEnumToDisplay = enumToNameWithDefault(PaymentMethod, paymentMethodConfig);

const paymentMethodEnumToDisplayWithPrefix = enumToNameWithDefault(PaymentMethod, paymentMethodConfig, true);

export {
  PaymentMethod,
  paymentMethodEnumToDisplay,
  paymentMethodEnumToDisplayWithPrefix,
  rawValueToPaymentMethod,
};
